import {useContext} from 'react';
import {
  ErpUiRouterContext,
  ErpUiRouterContextModel,
} from '../components/react-router/erp-react-router-context';
import {RawParams, StateOrName} from '@uirouter/angular';
import {TransitionOptions} from '@uirouter/core';

export function useErpUiRouterContext(): ErpUiRouterContextModel {
  const routerContext = useContext(ErpUiRouterContext);
  const routerContextNull = (routerContext.context ?? null) === null;

  const routeAngular: (
    to: StateOrName,
    params?: RawParams,
    options?: TransitionOptions,
  ) => Promise<boolean> | null = async (
    to,
    params,
    options,
  ) => {
    if (routerContextNull || (routerContext.context.routeAngular ?? null) === null) {
      return null;
    }

    await routerContext.context.routeAngular(to, params, options);
  };

  return {
    currentParameters: routerContextNull ? null : routerContext.context?.currentParameters ?? null,
    routeAngular: routeAngular,
  };
}
